import React from "react";

type Props = {
  children?: React.ReactNode;
};

const Left: React.FC<Props> = ({ children }) => <div className="col-left">{children ?? null}</div>;

export default Left;
